import React, { useEffect } from 'react';
import { useState } from 'react';

import { Select } from 'antd';

import api from '../../api';

export default function ComboEventiTipi({ placeholder, onChange }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {
        try {
            const result = await api.get('CRM/Clienti/EventiTipi');

            console.log(result);
            if (result != null && result.data) {
                setData(result.data);
            }
        } catch (error) {
            console.log(error);
        }
    }
    const handleSelectChange = (value) => {
        onChange(value); // Call the onChange callback with the selected value
    };

    const opt = data?.map((item) => ({
        key: item.idTipoEvento,
        value: item.idTipoEvento,
        label: item.descrizioneTipo,
    }));

    return <Select placeholder={placeholder} options={opt} onChange={handleSelectChange}></Select>;
}
